module.exports = __webpack_public_path__ + "static/1-5187037ec752fe8968c1abfac5e7d7d7.svg";